// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>39</span>&nbsp;&nbsp;You have broken the covenant with your servant,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and have cast his crown to the dust.<br> </p> </div></div>";
// Exports
module.exports = code;